import type { LevelDefinition, LevelId } from "../domain/types";
import {
  parseLevel,
  parseOperationalConfig,
  type OperationalConfig,
} from "./schema";

export type { OperationalConfig } from "./schema";

const LEVEL_IDS: readonly LevelId[] = ["vida", "soat", "rentas"];

async function fetchJson(path: string): Promise<unknown> {
  const response = await fetch(new URL(path, document.baseURI));
  if (!response.ok)
    throw new Error(`Could not load ${path}: HTTP ${response.status}`);
  return response.json() as Promise<unknown>;
}

export async function loadContent(): Promise<{
  levels: Record<LevelId, LevelDefinition>;
  operational: OperationalConfig;
}> {
  const [rawLevels, rawOperational] = await Promise.all([
    Promise.all(
      LEVEL_IDS.map(async (id) =>
        parseLevel(await fetchJson(`content/${id}.json`)),
      ),
    ),
    fetchJson("content/settings.json").then(parseOperationalConfig),
  ]);
  const levels = Object.fromEntries(
    rawLevels.map((level) => [level.id, level]),
  ) as Record<LevelId, LevelDefinition>;
  return { levels, operational: rawOperational };
}
